import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { usePostInquiryTractorMutation } from '../../../../hooks/api/inquiry/mutations/usePostInquiryTractor.mutation';
import { usePatchUserFlarelaneTagsMutation } from '../../../../hooks/api/user/mutations/usePatchUserFlarelaneTags.mutation';
import { useGetUsersMeQuery } from '../../../../hooks/api/user/queries/useGetUsersMe.query';
import { useRedirectToStoredPage } from '../../../../hooks/page/useRedirectToStoredPage';
import { postMessageToRN } from '../../../../utils/RNCommunicator/postMessageToRN.util';
import { LoadingPage } from '../../../etc/LoadingPage/LoadingPage';

export const AfterLoginPage = () => {
  const navigate = useNavigate();

  const getUsersMeQuery = useGetUsersMeQuery();

  const { mutate: patchUserFlarelaneTags } = usePatchUserFlarelaneTagsMutation();
  const { mutate: postUserInquiryTractor } = usePostInquiryTractorMutation();

  const { navigateToStoredPage } = useRedirectToStoredPage();

  useEffect(() => {
    if (getUsersMeQuery.data?.id) {
      if (window.ReactNativeWebView) {
        postMessageToRN({ messageKey: 'setUserId', messageParam: getUsersMeQuery.data?.id });
      }

      setTimeout(() => {
        patchUserFlarelaneTags();
      }, 10000);

      if (sessionStorage.getItem('failedInquiryTractorId')) {
        const failedInquiryTractorId = sessionStorage.getItem('failedInquiryTractorId');
        postUserInquiryTractor({ reqBody: { productId: failedInquiryTractorId! } });
        sessionStorage.removeItem('failedInquiryTractorId');
      }

      // 회원가입 성공 시 => 회원가입 완료 페이지로 이동
      if (sessionStorage.getItem('join-complete') === 'true') {
        sessionStorage.removeItem('join-complete');
        navigate('/join-complete', { replace: true });
      } else {
        // 전에 보던 페이지로 이동
        navigateToStoredPage();
      }
    }
  }, [getUsersMeQuery, navigate, patchUserFlarelaneTags]);

  return <LoadingPage />;
};
